import type { AuthRepository, TwoFactorMethod, TwoFactorMethodStatus } from '@contexts/auth/domain';
import type { UseCase } from '@contexts/shared/application';
import { booleanValueObject, stringValueObject } from '@contexts/shared/domain';

export type Update2FAMethodInput = {
	methodId: string;
	status?: TwoFactorMethodStatus;
	isDefault?: boolean;
};

export type Update2FAMethodUseCase = UseCase<Update2FAMethodInput, TwoFactorMethod>;

export function update2FAMethodBuilder(authRepository: AuthRepository): Update2FAMethodUseCase {
	return async function update2FAMethod(input: Update2FAMethodInput): Promise<TwoFactorMethod> {
		const methodId = stringValueObject().validate('methodId', input.methodId);
		const status = stringValueObject().validateOptional('status', input.status);
		const isDefault = booleanValueObject().validateOptional('isDefault', input.isDefault);

		return authRepository.update2FAMethod(methodId, status, isDefault);
	};
}
